import React from 'react'
import Switch from '@material-ui/core/Switch'

class ButtonWithSwitchComponent extends React.Component {
  render () {
    return (
      <div style={styles.content}>
        <div style={this.props.checked ? styles.checkedButton : styles.uncheckedButton}
          onClick={this.props.onClick}>
          <table cellSpacing='0' cellPadding='0' style={styles.table}>
            <tbody>
              <tr>
                <td>
                  <span style={this.props.checked ? styles.checkedLabel : styles.uncheckedLabel}>{this.props.label}</span>
                </td>
                <td style={styles.tdSwitch}>
                  <Switch
                    checked={this.props.checked}
                    onChange={this.props.handleChange}
                    color='primary'
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

const styles = {
  content: {
    width: 'auto',
    float: 'right',
    height: '26px',
    marginTop: '10px',
    marginRight: '14px'
  },
  checkedButton: {
    border: 'none',
    float: 'right',
    cursor: 'pointer',
    width: 'auto',
    height: '26px',
    borderRadius: '10px',
    backgroundColor: '#7ED321'
  },
  uncheckedButton: {
    float: 'right',
    cursor: 'pointer',
    width: 'auto',
    height: '26px',
    border: '1px solid #748591',
    borderRadius: '10px',
    backgroundColor: '#374148'
  },
  checkedLabel: {
    marginLeft: '14px',
    marginRight: '12px',
    color: '#272D31',
    fontSize: '12px',
    fontWeight: 700
  },
  uncheckedLabel: {
    marginLeft: '14px',
    marginRight: '12px',
    color: '#748591',
    fontSize: '12px',
    fontWeight: 700
  },
  tdSwitch: {
    paddingTop: '2px'
  },
  table: {
    border: 'none',
    marginTop: '-13px'
  }
}

export default ButtonWithSwitchComponent
